// Bootstrap нового owner web на ai.zafrm.pro (canonical с 2026-06-20,
// domain-routing-normalization; alias aiteam.zafrm.pro — 301-compat).
// Спринт: ai-agents-new-frontend.
//
// Слои в порядке наружу→внутрь (после Шага 2):
//   ThemeProvider(aurora-nocturne)
//     QueryClientProvider(TanStack Query, singleton из api/queryClient.ts)
//       BrowserRouter
//         AuthGuard(/api/auth/me, redirect на /api/auth/login при 401)
//           App (AppShell + ProductTopBar + 9-pt sub-nav + <AppRoutes> + ToastHost)
//
// Почему такой порядок:
//   - Theme до Query: токены/CSS-переменные должны быть применены до того, как
//     дочерние компоненты, использующие @frm/ui, начнут рендериться.
//   - Query до Router: useQuery в любом маршруте требует QueryClient в дереве.
//   - Router до AuthGuard: AuthGuard может редиректнуть и сам хочет использовать
//     navigate() / hooks роутера (для будущих route-aware redirects).
//   - AuthGuard до App: контент панели рендерится только после 200 от /api/auth/me.

import '@frm/ui/tokens.css'
import './styles.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router'
import { AuthGuard, ThemeProvider } from '@frm/ui'

import { App } from './app/App'
import { queryClient } from './api/queryClient'

const container = document.getElementById('root')
if (!container) throw new Error('root element missing')

createRoot(container).render(
  <StrictMode>
    <ThemeProvider defaultTheme="aurora-nocturne">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthGuard fallback={<div style={{ padding: 24 }}>Loading…</div>}>
            <App />
          </AuthGuard>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
)
